import { FC, useMemo } from 'react'
import { createTheme } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import cs from 'date-fns/locale/cs'
import enUS from 'date-fns/locale/en-US'

import { useAppSelector } from '../../store/hooks'
import { App } from '../App'
import { I18nProvider } from '../I18nProvider'
import { darkThemeOptions, themeOptions } from './themeOptions'

const dateFnsLocales: Record<string, Locale> = { en: enUS, cs }

export const LocalizedThemedContainer: FC = () => {
  const isDarkThemeOn = useAppSelector((state) => state.userOptions.darkTheme)
  const language = useAppSelector((state) => state.userOptions.locale)
  const theme = useMemo(() => createTheme(isDarkThemeOn ? darkThemeOptions : themeOptions), [isDarkThemeOn])
  const dateFnsLocale = dateFnsLocales[language] ?? enUS

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={dateFnsLocale}>
        <I18nProvider language={language}>
          <App />
        </I18nProvider>
      </LocalizationProvider>
    </ThemeProvider>
  )
}
